import { SharedDataService } from './../../services/sharedData.service';
import { TrackingService } from 'app/services/tracking.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-abandon-redirect',
  template: ''
})
export class AbandonRedirectComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sharedService: SharedDataService,
    private trackingService: TrackingService
  ) {}

  ngOnInit() {
    const flowId = this.route.snapshot.queryParamMap.get('flowId') 
            || this.sharedService.getFlowId();

  
    if (!flowId) {
      // If no ID, just go to billing
      this.router.navigate(['/billing']);
      return;
    }

    // 2. Navigate to billing
      this.router.navigate(['/billing'], {
        queryParams: { flowId }
      });

  }
}
